// extracted by mini-css-extract-plugin
export default {"page":"adminpage_page__6QE1K","AdminBlock":"adminpage_AdminBlock__1IKvH"};